export const sendNFTRoutes = [
  {
    path: 'nft/send/nft',
    name: 'send_nft',
    component: () => import('@/views/dashboard/send/nft/SendNFTMain.vue'),
    children: [
      {
        path: 'destination',
        name: 'send_nft_destination',
        component: () => import('@/views/dashboard/send/InputDestination.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
      {
        path: 'fee_routing',
        name: 'send_nft_fee_routing',
        component: () =>
          import(
            '@/views/dashboard/send/nft/branches/FeeRoutingMiddleware.vue'
          ),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
      {
        path: 'select_network_fee',
        name: 'send_nft_network_fee',
        component: () =>
          import('@/views/dashboard/send/nft/SelectNetworkFee.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
      {
        path: 'custom_fee_evm',
        name: 'send_nft_network_custom_fee_evm',
        component: () =>
          import('@/views/dashboard/send/nft/CustomNetworkFee.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
      {
        path: 'confirmation',
        name: 'send_nft_confirmation',
        component: () => import('@/views/dashboard/send/nft/ConfirmNFT.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
      {
        path: 'input_pin',
        name: 'send_nft_input_pin',
        component: () => import('@/views/dashboard/send/nft/SendNFTPin.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
    ],
  },
  {
    path: 'nft/:walletId/detail/send/nft',
    name: 'wallet_send_nft',
    component: () => import('@/views/dashboard/send/nft/SendNFTMain.vue'),
    children: [
      {
        path: 'select-nft',
        name: 'send_nft_select',
        component: () => import('@/views/dashboard/send/nft/SelectNFT.vue'),
        meta: {
          PageTitle: 'nft.nft_send',
        },
      },
    ],
  },
  {
    path: 'nft/send/nft/complete',
    name: 'send_nft_complete',
    component: () =>
      import('@/views/dashboard/send/nft/branches/SendNFTComplete.vue'),
    meta: {
      PageTitle: 'nft.nft_send',
    },
  },
]
